module.exports = __webpack_public_path__ + "static/media/trainers-bg-bg.eae218c1.jpg";